var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTryaskingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60744 15.8924C5.77288 17.0578 7.25774 17.8515 8.87425 18.173C10.4908 18.4946 12.1663 18.3296 13.689 17.6988C15.2117 17.0681 16.5132 16 17.4289 14.6296C18.3446 13.2592 18.8333 11.648 18.8333 9.99984C18.8333 8.35166 18.3446 6.7405 17.4289 5.37009C16.5132 3.99968 15.2117 2.93157 13.689 2.30084C12.1663 1.67011 10.4908 1.50508 8.87425 1.82663C7.25774 2.14817 5.77288 2.94184 4.60745 4.10728",
    stroke: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.0002L13.3904 9.68782L13.6403 10.0002L13.3904 10.3125L13 10.0002ZM3 10.5002C2.72386 10.5002 2.5 10.2763 2.5 10.0002C2.5 9.72402 2.72386 9.50016 3 9.50016V10.5002ZM10.0571 5.52115L13.3904 9.68782L12.6096 10.3125L9.27623 6.14584L10.0571 5.52115ZM13.3904 10.3125L10.0571 14.4792L9.27623 13.8545L12.6096 9.68782L13.3904 10.3125ZM13 10.5002H3V9.50016H13V10.5002Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryaskingicon);
export default __webpack_public_path__ + "static/media/tryaskingicon.faea6694f3c2eda28b2569b5b0ae2bf0.svg";
export { ForwardRef as ReactComponent };